module.exports = __webpack_public_path__ + "static/1.2_550x402_Pill_Desktop_1X-36e4af0b6be27f7cd2f0cf072db08dbe.png";